import React from 'react'
import styled from 'styled-components'

import Button from '../../atoms/Button'
import ButtonText, { ECUrlType } from './ButtonText'
import OuterLink from '../../atoms/OuterLink'

/**
 * ボタンの並び順
 */
const DISPLAY_POSITIONS: { [key in ECUrlType]: number } = {
  amazon: 1,
  rakuten: 2,
  yahoo: 3,
  wowma: 4,
  toysrus: 5,
  akachan: 6,
  official: 7,
  landing: 8,
}

const Container = styled.div`
  margin: 16px auto 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 25px 0 0;
    width: 100%;
  }
`

const DesktopListContainer = styled.div`
  width: 280px;
  @media (max-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    display: none;
  }
`

const MobileListContainer = styled.div`
  width: 340px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    display: none;
  }
`

const List = styled.ul`
  flex-direction: column;
  height: 100%;
  list-style: none;
  align-items: start;
  display: grid;
  grid-gap: 7px;
  grid-auto-rows: 44px;
  grid-template-columns: repeat(2, 160px);
  justify-content: start;

  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    grid-gap: 15px;
    grid-template-columns: repeat(2, 270px);
  }
`

const ListItemButton = styled(Button)`
  padding: 0 16px;
  height: 44px;
`

const ListItemNarrowButton = styled(Button)`
  width: 160px;
  padding: 0 16px;
  height: 44px;
`

const Link = styled(OuterLink)`
  text-decoration: none;
`

function handleClickECLink(url: string) {
  window.ga('send', {
    hitType: 'event',
    eventCategory: 'EC Link',
    eventAction: 'click',
    eventLabel: 'Award 2022 Spring',
    eventValue: url,
  })
}

type Props = {
  officialUrl: string
  ecUrls: { type: ECUrlType; url: string }[]
}

export default function ECLinkList({ officialUrl, ecUrls }: Props) {
  if (!officialUrl && !ecUrls.length) return <></>

  const official: { type: ECUrlType; url: string }[] = officialUrl ? [{ type: 'landing', url: officialUrl }] : []
  const sortedECUrls = [...(ecUrls.length ? ecUrls : []), ...official].sort(
    (a, b) => DISPLAY_POSITIONS[a.type] - DISPLAY_POSITIONS[b.type]
  )

  return (
    <Container>
      {/* Desktop */}
      <DesktopListContainer>
        <List>
          {sortedECUrls.map(({ type, url }, index) => (
            <li key={index}>
              <Link onClick={() => handleClickECLink(url)} to={url}>
                <ListItemButton color="white">
                  <ButtonText type={type} />
                </ListItemButton>
              </Link>
            </li>
          ))}
        </List>
      </DesktopListContainer>

      {/* Mobile */}
      <MobileListContainer>
        <List>
          {sortedECUrls.map(({ type, url }, index) => (
            <li key={index}>
              <Link onClick={() => handleClickECLink(url)} to={url}>
                <ListItemNarrowButton color="white">
                  <ButtonText type={type} />
                </ListItemNarrowButton>
              </Link>
            </li>
          ))}
        </List>
      </MobileListContainer>
    </Container>
  )
}
